import { Box, Typography } from "@mui/material";
import ReviewBox from "../../components/reviewBox";
import { t } from "i18next";

const Reviews = ({ reviews }) => {
  return (
    <Box paddingY={5}>
      {reviews?.length > 0 ? (
        <ReviewBox data={reviews} />
      ) : (
        <Typography variant="h5" textAlign={"center"} my={3} fontWeight={600}>
          {t("noReviews")} !
        </Typography>
      )}
    </Box>
  );
};

export default Reviews;
